export default __webpack_public_path__ + "static/media/grizzly.9476ccac.png";